import firebase from 'firebase/compat/app';
import withoutNulls from '../api/search/withoutNulls';
import STORE_CONSTANTS from './constants';

const labelConverter = {
  toFirestore(entity: FleetOps.Label): firebase.firestore.DocumentData {
    return withoutNulls({ ...entity });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<FleetOps.Label>,
    options: firebase.firestore.SnapshotOptions,
  ): FleetOps.Label {
    const data = {
      ...snapshot.data(options),
    };
    return data;
  },
};

const getLabelsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.LABELS_COLLECTION)
    .withConverter(labelConverter);
};

export default getLabelsRef;
